module.exports = __webpack_public_path__ + "img/InstagramBusiness.a02df372.svg";